import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getParkingVoucherTemplates(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("parking-voucher-templates?" + parameters);
  return data;
}

export async function getParkingVoucherTemplate(id) {
  const { data } = await axios.get("parking-voucher-templates/" + id);
  return data;
}

export async function createParkingVoucherTemplate(values) {
  const { data } = await axios.post("parking-voucher-templates", values);
  return data;
}

export async function updateParkingVoucherTemplate(id, values) {
  const { data } = await axios.put("parking-voucher-templates/" + id, values);
  return data;
}

export async function deleteParkingVoucherTemplate(id) {
  const { data } = await axios.delete("parking-voucher-templates/" + id);
  return data;
}
